import React from "react";
import {
  Checkbox,
  Dialog,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

// import AButton from "../common/AButton";
// import IconButtonWrapper from "../common/IconButtonWrapper";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { NOTIFY_CHANNELS } from "./constant";
import { CheckIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/CheckIcon";
import { FailedIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/FailedIcon";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import ALoader from "views/pages/manage/common/a-loader";

const NotificationDialog = ({
  open,
  handleCloseDialog,
  details,
  logicHook,
  detailFields,
  transferReason,
  transferType,
  payloadData,
  templateName,
  dataEndpoint
}) => {
  const {
    checked,
    notifResponse = { data: [], message: '' },
    isNotifSent,
    loading,
    handleChange,
    handleSendNotification,
    setIsNotifSent,
  } = logicHook;

  const isBtnDisabled = !Object.values(checked).some(Boolean);

  const FIELDS = detailFields ?? React.useMemo(
    () => [
      { label: "Request ID", value: details?.requestNo || "-" },
      { label: "PSID", value: details?.psid || "-" },
      { label: "Mobile number", value: details?.phoneNumber || "-" },
      { label: "Email ID", value: details?.studentEmailId || "-" },
    ],
    [details]
  );

  return (
    <>
      <Dialog open={open} onClose={handleCloseDialog}>
        {loading&&<ALoader position="fixed"/>}
        <div style={{ padding: "22px 24px", width: "600px" }}>
          <header className="d-flex justify-content-between align-items-center">
            <h2 style={{ color: "#262626", fontFamily: "Gilroy-Medium" }}>
              Send Notification
            </h2>
            <IconButtonWrapper onClick={handleCloseDialog}>
              <CrossIcon />
            </IconButtonWrapper>
          </header>

          <p
            style={{
              fontWeight: "600",
              fontFamily: "Gilroy-Medium",
              marginBottom: 0,
            }}
          >
            Student details
          </p>

          <div className="d-flex flex-column py-2 border-bottom">
            {FIELDS.map(({ label, value }, idx) => (
              <div
                key={idx}
                className="d-flex justify-content-between align-items-center"
              >
                <label className="text-sm">{label}</label>
                <strong>{value}</strong>
              </div>
            ))}
          </div>

          <p className="pt-3 fw-bold">Select mode</p>

          <FormGroup className="flex-row justify-content-between" style={{ width: "90%" }}>
            {NOTIFY_CHANNELS.map(({ label, name }) => (
              <FormControlLabel
                key={name}
                control={
                  <Checkbox
                    checked={checked[name]}
                    onChange={handleChange}
                    name={name}
                    style={{ color: "#00B0F5" }}
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>

          <AButton
            className="w-100 mt-2"
            variant="primary_filled"
            onClick={handleSendNotification}
            disabled={isBtnDisabled || loading}
          >
            {loading ? "Sending..." : "Send Notification"}
          </AButton>
        </div>
      </Dialog>

      {isNotifSent && (
        <NotificationSuccessDialog
          isOpen={isNotifSent}
          notifResponse={notifResponse}
          selectedModes={checked}
          handleCloseDialog={() => setIsNotifSent(false)}
        />
      )}
    </>
  );
};

export default NotificationDialog;
const NotificationSuccessDialog = ({
  isOpen,
  handleCloseDialog,
  notifResponse = { data: [], message: '' },
  selectedModes,
}) => {
  React.useEffect(() => {
    // auto-close
    setTimeout(() => {
      handleCloseDialog();
    }, 4000);
  }, []);

  const isAllNotifFail = notifResponse?.data ? !notifResponse.data.some(
    ({ isNotificationSent }) => isNotificationSent
  ) : true;

  return (
    <Dialog
      onClose={handleCloseDialog}
      open={isOpen}
      classes={{
        paper: {
          borderRadius: "12px",
        },
      }}
    >
      <div style={{ padding: "22px 24px", width: "450px" }}>
        <h1
          style={{
            fontWeight: "600",
            fontFamily: "Gilroy-Medium",
            marginTop: "0.5rem",
          }}
        >
          {isAllNotifFail
            ? "Sending notification failed"
            : "Notification has been sent"}
        </h1>

        <p className="text-sm">{notifResponse.message}</p>

        {NOTIFY_CHANNELS.map(({ label, name }) => {
          const renderedChannel = notifResponse.data.filter(
            ({ channel }) => channel.toLowerCase() === name
          );

          return (
            <div className="d-flex align-items-center mb-2">
              {renderedChannel.length &&
                renderedChannel[0].isNotificationSent ? (
                <CheckIcon />
              ) : selectedModes[name] ? (
                <FailedIcon />
              ) : (
                <CheckIcon color="#AFAFAF" />
              )}

              <span className="text-sm" style={{ marginLeft: "0.7rem" }}>
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

